// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a1fa049e","239":"0a96c4fb","455":"9487327a"}[chunkId] + ".chunk.js";
};